/* eslint-disable import/prefer-default-export */
export const colorMapper = (namesToMap, colorScheme) => namesToMap.reduce(
  (colorMap, name) => colorMap.set(name, colorScheme.get(name) || '#1E2B38'),
  new Map(),
);
